import { border, flex, gap, padding, radius } from '@ebh/capsule/theme';
import { css } from '@emotion/react';

export default {
  container: css`
    ${[
      flex('column', 'items-center', 'justify-center'),
      gap(6),
      border(1, 'primary-400'),
      padding(8),
      radius(3),
    ]}
  `,
  body: css`
    ${[flex('column', 'items-center', 'justify-center'), gap(4)]}
  `,
  noSearchIcon: css`
    ${[flex('column', 'items-center'), gap(1)]}
  `,
  heading: css`
    ${[flex('column', 'items-center'), gap(2)]}
  `,
  buttonWrapper: css`
    ${[flex('row', 'justify-center'), { cursor: 'pointer' }]}
  `,
  button: css`
    ${[padding(3, 'left'), padding(3, 'right')]}
  `,
};
